<main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in">
        <div class="container">
            <h2 class="marathi-font" [innerHTML]="'स्थान: '+sthanLocation.marathiname+ ', जिल्हा: '+ sthanLocation.city"></h2>
        </div>
    </div><!-- End Breadcrumbs -->
    <section style="padding-top:0px;padding-bottom:0px">
        <div data-aos="fade-up">

            <google-map
            #myGoogleMap
            
            height="500px"
            width="100%"
            [zoom]="zoom"
            [center]="center"
            [options]="options"
            (mapClick)="eventHandler($event,'mapClick')"
            (mapDblclick)="eventHandler($event,'mapDblclick')"
            (mapDrag)="eventHandler($event,'mapDrag')"
            (mapDragend)="eventHandler($event,'mapDragend')"
            (mapRightclick)="eventHandler($event,'mapRightclick')"
            (positionChanged)="eventHandler($event,'marker_positionChanged')"
            (idle)="eventHandler($event,'idle')"
            (tilesloaded)="eventHandler($event,'tilesloaded')"
            (zoomChange)="changeMapZoom($event)" >
          
            <map-marker

              #markerElem="mapMarker"
              *ngFor="let marker of markers"
              [position]="marker.position"
              [label]="marker.label"    
              [title]="marker.title"
              [options]="marker.options"
              (mapClick)="openInfo(markerElem, marker.info)"
            >
            </map-marker>
          
            <map-info-window>{{ infoContent }}</map-info-window>
          </google-map>

            <!-- <iframe style="border:0; width: 100%; height: 350px;" 
            [src]="sthanUrl" 
            frameborder="0" allowfullscreen></iframe> -->
          </div>
    </section>
    

    <section  >
        <div class="container" data-aos="fade-up">

            <div class="section-title pb-0">
                <h2>Read Online</h2>
                <p class="marathi-font">स्थानाची माहिती</p><br>
              </div>
            <p class="marathi-font" [innerHTML]="sthanLocation.info"></p>
        </div>
    </section>

    <section style="padding-top:0px">
        <div class="container" data-aos="fade-up">

            <div class="section-title pb-0">
                <h2>Read Online</h2>
                <p class="marathi-font">स्थानाच्या लीळा</p><br>
              </div>

              <app-accordion [items]="leelas" [loaderVisable]="inProgress" (searchText)="SearchText($event)" 
              [enableGlobalSearch]="false" [nextDataAvailable]="nextDataAvailable"></app-accordion>
        </div>
    </section>

    <section style="padding-top:0px">
        <div class="container" data-aos="fade-up">

            <div class="section-title">
                <h2>Read Online</h2>
                <p >Images</p><br>
            </div>

           <app-imagegrid [gallery_col1]="gallery_col1" 
           [gallery_col2]="gallery_col2"
           [gallery_col3]="gallery_col3"
           [gallery_col4]="gallery_col4"></app-imagegrid>
        </div>
    </section>
</main>